import { render, staticRenderFns } from "./BlockSafety.vue?vue&type=template&id=f1d370b0&scoped=true"
import script from "./BlockSafety.vue?vue&type=script&lang=js"
export * from "./BlockSafety.vue?vue&type=script&lang=js"
import style0 from "./BlockSafety.vue?vue&type=style&index=0&id=f1d370b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d370b0",
  null
  
)

export default component.exports